import React, { createContext, useCallback, useContext, useState } from "react";

interface BookingSuccessContextValue {
  isOpen: boolean;
  showBookingSuccess: () => void;
  hideBookingSuccess: () => void;
}

const BookingSuccessContext = createContext<BookingSuccessContextValue | null>(
  null,
);

export const BookingSuccessProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const showBookingSuccess = useCallback(() => setIsOpen(true), []);
  const hideBookingSuccess = useCallback(() => setIsOpen(false), []);

  return (
    <BookingSuccessContext.Provider
      value={{ isOpen, showBookingSuccess, hideBookingSuccess }}
    >
      {children}
    </BookingSuccessContext.Provider>
  );
};

export const useBookingSuccess = (): BookingSuccessContextValue => {
  const ctx = useContext(BookingSuccessContext);
  if (!ctx)
    throw new Error(
      "useBookingSuccess must be used within BookingSuccessProvider",
    );
  return ctx;
};
